import React, { useState } from 'react';
import Filters from './Filters/Filters';
import Elements from './Elements/Elements';
import { makeStyles } from '@material-ui/core/styles';
import { FiltersInterface } from './consts';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1
  }
}));

const SubscriptionGrid = () => {
  const classes = useStyles();
  const [filters, setFilter] = useState<FiltersInterface>({});

  const updateFilters = (filters: FiltersInterface) => {
    setFilter(filters);
  };

  return (
    <div className={classes.container}>
      <Filters onFiltersUpdated={updateFilters}></Filters>
      <Elements filters={filters}></Elements>
    </div>
  );
}

export default SubscriptionGrid;